<template>
    <v-container class="max-container">
        <v-row v-if="sweepstakesGroup.length > 0">
            <span class="container_row__title--screen">Sorteios</span>
            <v-col v-for="sweepstakes in sweepstakesGroup" :key="sweepstakes.id" class="no-pd-l" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-card elevation="3" class="container_row_col__card">
                    <v-card-text class="flex-row-start no-pd">
                        <v-col class="no-pd" cols="4" sm="3" md="3" lg="2" xl="2">
                            <v-img v-if="sweepstakes.banner" class="card_col__img" :src="sweepstakes.banner"/>
                            <v-img v-if="!sweepstakes.banner" class="card_col__img" src="@/assets/sweepstakes/default_sorteio_web.png" />
                        </v-col>
                        <v-col class="flex-col-start no-pd-t no-pd-b no-pd-r" cols="8" sm="9" md="9" lg="10" xl="10">
                            <v-col class="flex-row-start no-pd-l">
                                <span class="card_col_title--card">{{sweepstakes.title}}</span>
                                <span :class="sweepstakes.activated ? 'sweepstakes--actived' : 'sweepstakes--disabled'">{{sweepstakes.activated ? 'PARTICIPANDO' : 'NÃO ESTÁ PARTICIPANDO'}}</span>
                            </v-col>
                            <v-col class=" no-pd-b no-pd-l no-pd-t">
                                <span class="card_col_subtitle--card">Data do sorteio</span>                                    
                                <div class="flex-row-space-between">
                                    <span class="card_col_date">{{ getDateByTimeStamp( sweepstakes.dateDraw ) + ' - ' +  getHourByTimeStamp( sweepstakes.dateDraw )}}</span>
                                    <v-btn  text color="#EE5D09" class="btn-heigth" @click="goToSweepstakesDetail(sweepstakes.id)">Saiba mais</v-btn>
                                </div>                                
                            </v-col>
                        </v-col>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row class="flex-row-center" v-else>
            <div>
                <v-img class="div__emptyimg" src="@/assets/empty-views/empty_sweepstakes.svg" /> 
            </div>                                 
        </v-row>     
    </v-container>
</template>

<script>
//Store
import { mapGetters } from "vuex";

//Services
import { getRafflesByCompanyIdAndCurrentContactId } from "@/app/components/sweepstakes/service/sweepstakes.service";

export default {
    name: 'sweepstakes',
    computed: {
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        )
    },
    data: () => ({
        sweepstakesGroup: []
    }),
    created() {
        this.getAllSweepstakes()
    },
    methods: {
        goToSweepstakesDetail( sweepstakesId ) {
            this.$router.push({path: `/detalheSorteio?sweepstakesId=${sweepstakesId}`})
        },
        getAllSweepstakes() {
            getRafflesByCompanyIdAndCurrentContactId(this.currentCompany.id) 
                .then( success => {
                        this.sweepstakesGroup = success.data                        
                    }
                )
                .catch( error => {
                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        },
        getHourByTimeStamp( data ){
            var moment = require('moment')
            var formatted = moment(data).format("HH:mm")
            return formatted
        },
        getDateByTimeStamp( data ){
            var moment = require('moment')
            var formatted =  moment(data).format("DD/MM/YYYY")
            return formatted;
        },

    }
}
</script>

<style scoped>
.div__emptyimg {    
    width: 388px;
}
.container_row_col__card {
    max-height: 136px;
    min-height: 136px;
    border-radius: 8px !important;
}
.card_col__img {
    max-height: 136px;
    min-height: 136px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}
.container_row__title--screen {
    font-weight: 800;
    font-size: 24px;
}
.card_col_title--card {
    font-size: 18px;
    font-weight: 700;
    margin-right: 10px;
    color: var(--cor--preta)
}
.card_col_subtitle--card {
    font-size: 16px;
    font-weight: 700;
    color: var(--cor--preta)
}
.card_col_date {
    font-size: 14px;
    font-weight: 600;
    color: var(--cor--preta)
}
.sweepstakes--actived {
    color: var(--cor--verde);
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.50px;
}
.sweepstakes--disabled {
    color: var(--cor--roza);
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.50px;
}
.btn-heigth {
    height: 20px !important;
}
</style>